import React from 'react';

const portfolio = [
  {
    id: 1,
    title: 'AI Finance Dashboard',
    category: 'AI-Driven Finance',
    description: 'Intelligent financial analytics platform with predictive modeling',
    image: 'https://images.pexels.com/photos/7109243/pexels-photo-7109243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 2,
    title: 'SaaS Product Platform',
    category: 'SaaS Web & App Development',
    description: 'Scalable SaaS application with multi-tenant architecture and modern UX',
    image: 'https://images.unsplash.com/photo-1648134859179-ed0c98f54519?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBTYWFTJTIwYXBwbGljYXRpb24lMjBpbnRlcmZhY2V8ZW58MHx8fHwxNzc1MzQyNjExfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    title: 'Automated Content System',
    category: 'YouTube Automation',
    description: 'End-to-end video production and publishing workflow',
    image: 'https://images.unsplash.com/photo-1686061592315-af9342dc8d74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHx2aWRlbyUyMHByb2R1Y3Rpb24lMjBjb250ZW50JTIwY3JlYXRpb258ZW58MHx8fHwxNzc1MzQyNjExfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    title: 'Smart Chatbot Platform',
    category: 'Chatbot Development',
    description: 'Multi-channel conversational AI with natural language understanding',
    image: 'https://images.unsplash.com/photo-1762328862557-e0a36587cd3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxBSSUyMGNoYXRib3QlMjB0ZWNobm9sb2d5JTIwaW50ZXJmYWNlfGVufDB8fHx8MTc3NTM0MjYxMXww&ixlib=rb-4.1.0&q=85'
  }
];

const PortfolioSection = () => {
  return (
    <section id="portfolio" className="py-20 px-4 bg-gray-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-sm text-black mb-6 font-semibold" style={{ fontFamily: 'Courier New, monospace' }}>/ Portfolio Projects</p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-6">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-black">
              Selected <span className="text-orange-500 font-bold">Work</span>
            </h2>
          </div>
          <p className="text-base text-black font-medium max-w-3xl leading-relaxed">
            A carefully picked showcase of projects that highlight commitment to execution quality and technical capability.
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {portfolio.map((project, index) => (
            <div
              key={project.id}
              className="group cursor-pointer overflow-hidden rounded-[30px] bg-white shadow-sm hover:shadow-2xl transition-all duration-700 relative"
              style={{
                animationDelay: `${index * 0.15}s`,
                animation: 'slide-up 0.8s ease-out forwards',
                opacity: 0,
                transform: 'perspective(1000px)',
                transformStyle: 'preserve-3d'
              }}
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-125"
                  style={{
                    transform: 'translateZ(0)',
                    willChange: 'transform'
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-700">
                  <div className="absolute inset-0 flex items-center justify-center transform translate-y-8 group-hover:translate-y-0 transition-transform duration-700">
                    <div className="text-center">
                      <p className="text-white text-2xl font-light mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-100">
                        {project.title}
                      </p>
                      <p className="text-white/80 text-sm font-light opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-200">
                        View Details →
                      </p>
                    </div>
                  </div>
                  {/* Animated border effect */}
                  <div className="absolute inset-0 border-2 border-orange-500/0 group-hover:border-orange-500/50 transition-all duration-700 m-4 rounded-2xl"></div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 relative overflow-hidden">
                {/* Animated background on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <p className="text-xs text-orange-500 mb-2 font-semibold tracking-wide transition-all duration-300 group-hover:tracking-widest" style={{ fontFamily: 'Courier New, monospace' }}>
                    {project.category}
                  </p>
                  <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 transition-all duration-300 group-hover:translate-x-2">
                    {project.title}
                  </h3>
                  <p className="text-black font-medium text-sm leading-relaxed transition-all duration-300 group-hover:text-black">
                    {project.description}
                  </p>
                </div>

                {/* Decorative element */}
                <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-orange-500 to-transparent opacity-0 group-hover:opacity-20 transition-opacity duration-500 rounded-tl-[30px]"></div>
              </div>
            </div>
          ))}
        </div>

        {/* View Complete Portfolio Button */}
        <div className="text-center">
          <p className="text-sm text-black font-semibold" style={{ fontFamily: 'Courier New, monospace' }}>
            Updated portfolio showcase, as of 2026
          </p>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;